import { getNodeIdComposer } from '@utils';
import { RootPrefix } from '../../constants';

export const modelDetailsId = getNodeIdComposer(RootPrefix, 'model_details');
export const nonCadDetailsId = getNodeIdComposer(RootPrefix, 'non_cad_details');
